import React, { useState, useEffect, useRef } from 'react';
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { Link, Navigate, resolvePath } from "react-router-dom";
import {config} from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import { Button } from 'primereact/button';
import 'primeicons/primeicons.css';
import { Image } from "primereact/image";
import ShowError from "../shared/ShowError";
import ShowConfirm from "../shared/ShowConfirm";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import { Col, Form, Row } from 'react-bootstrap';



export default function SmsCharge(props) {
    const toast = useRef(null);
    const [errorVisible, setErorVisible] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [saving, setSaving] = useState(false);

    

    const [credit, setCredit] = useState("در حال دریافت...");
    const [url, setUrl] = useState("");


    useEffect(() => {
      var params = {login:util.getTrustedUser()};
      var url = config.Server+`/school/sms/credit/get`;
      axios
          .post(url, params )
          .then(res => {
              var response = res.data;
              if(response.state === "ok"){
                  response = response.data;
                  setCredit(util.SeperatePrice(response.amount));
                  setUrl(util.SeperatePrice(response.url));
              }
              else{
                  setErrorMessage(response.message);
                  setErorVisible(true);
                  setSaving(false);
              }
          })
          .catch(error => {
              setErrorMessage(error.code + "," + error.message);
              setErorVisible(true);
              setSaving(false);
          });
    }, []);

    return(      
      <>
         
          <div className="card" style={{width:"100%", maxWidth:"525px", borderBlockColor:"#414141",marginTop:"20px" }}>
            
          <table style={{width:"100%", borderCollapse:"collapse"}}>
            <tbody>
              <tr><td style={{backgroundColor:"royalblue", color:"#FFFFFF",padding:"5px", borderRadius:"5px", fontSize:"14pt", textAlign:"center"}}>شارژ پیامک</td></tr>
              <tr><td>&nbsp;</td></tr>
              <tr><td>اعتبار: {credit}</td></tr>
              <tr><td>&nbsp;</td></tr>
              <tr><td>&nbsp;</td></tr>
              {
                url == ""?
                <></>
                :
              <tr>
                <td>
                  <div className="card flex justify-content-center" style={{ direction: "ltr", textAlign:"right" }}>
                    <Button label="خرید شارژ" icon="pi pi-check" onClick={()=>{window.open(url);}} severity="success" iconPos="right" loading={saving} />
                    
                  </div>
                </td>
              </tr>

              }
              <tr><td colSpan={4}>&nbsp;</td></tr>

            </tbody>
          </table>            
          </div>
          <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
          <Toast ref={toast} />            
      </>  
    );
  
}
